<!-- una card -->
<div
  class="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
>
  <!-- header -->
  <div class="shrink-0 border-b border-slate-100 px-3 py-3 sm:px-4 sm:py-4">
    <div class="flex items-center justify-between gap-3">
      <div class="flex min-w-0 items-center gap-2 sm:gap-3">
        <span
          class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-50 text-accent-600 ring-1 ring-accent-100"
        >
          <i class="bi bi-cart4 text-xl"></i>
        </span>
        <div class="min-w-0">
          <h2 class="truncate text-base font-bold text-slate-900">Carrito</h2>
          <p class="text-[11px] font-medium text-slate-400 sm:text-xs">
            Revisa productos y precios antes de cobrar
          </p>
        </div>
      </div>

      <span
        class="hidden rounded-full bg-accent-50 px-2.5 py-1 text-xs font-semibold text-accent-700 sm:inline-flex"
      >
        {{ carritoCompraProductos?.length ?? 0 }}
      </span>
    </div>

    <div class="mt-3 flex items-center gap-2 sm:gap-2.5">
      <app-button
        icon="bi bi-plus-lg"
        variant="outline"
        size="sm"
        [rounded]="true"
        class="h-9! w-9! sm:h-8! sm:w-8!"
        appTooltip="Agregar producto libre"
        tooltipPosition="top"
        (onClick)="modal_producto_libre.set(true)"
      />
      <app-button
        icon="bi bi-trash"
        variant="ghost"
        size="sm"
        [rounded]="true"
        (onClick)="vaciarCarrito()"
        class="h-9! w-9! sm:h-8! sm:w-8!"
        [disabled]="!this.carritoCompraProductos || this.carritoCompraProductos.length == 0"
        appTooltip="Vaciar carrito"
        tooltipPosition="top"
      ></app-button>
      <span
        class="ml-auto rounded-full bg-accent-50 px-2.5 py-1 text-xs font-semibold text-accent-700 sm:hidden"
      >
        {{ carritoCompraProductos?.length ?? 0 }}
      </span>
    </div>
  </div>
  <!-- body -->
  <div class="min-h-0 flex-1 overflow-y-auto overscroll-contain px-2 py-2 sm:px-4 sm:py-3">
    @if (carritoCompraProductos && carritoCompraProductos.length > 0) {
      <div class="space-y-1 sm:space-y-0.5">
        @for (item of carritoCompraProductos; track $index) {
          <app-carrito-compra-producto [productoCarrito]="item" />
        }
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center h-full text-slate-400 gap-2 py-8">
        <i class="bi bi-cart-x text-3xl"></i>
        <span class="text-sm">Carrito vacío</span>
      </div>
    }
  </div>
  <!-- footer -->
  <div class="shrink-0 border-t border-slate-100 bg-white px-4 py-3 sm:px-5 sm:py-4">
    <div class="mb-3 flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2.5">
      <span class="text-sm font-medium text-slate-600">Total</span>
      <span class="text-base font-bold text-slate-900 sm:text-lg">{{
        total() | currency: 'PEN' : 'S/.'
      }}</span>
    </div>
    <app-button
      label="Procesar Pago"
      icon="bi bi-credit-card-2-front"
      variant="primary"
      class="w-full! rounded-xl! py-3! font-semibold!"
      (onClick)="procesarPago()"
      [disabled]="!(carritoCompraProductos && carritoCompraProductos.length > 0)"
    ></app-button>
  </div>
</div>
<app-dialog
  header="Realizar venta"
  [modal]="true"
  [(visible)]="modal_procesar_venta"
  [closeOnEscape]="false"
  size="6xl"
>
  @if (modal_procesar_venta() == true) {
    <app-procesar-venta
      (closedModal)="modal_procesar_venta.set(false)"
      (emitirVenta)="onEmitirVenta()"
    />
  }
</app-dialog>
<app-dialog
  header="Agregar Producto Libre"
  [modal]="true"
  [(visible)]="modal_producto_libre"
  [closeOnEscape]="false"
  size="sm"
>
  @if (modal_producto_libre() == true) {
    <app-agregar-producto-libre
      (closedModal)="modal_producto_libre.set(false)"
      (agregarProducto)="onAgregarProducto($event)"
    />
  }
</app-dialog>
